import axios from '@axios'

/** 
* Índice
* {@link getSeries} - Obtener series
* {@link getSerie} - Obtener serie
* {@link addSerie} - Crear serie
* {@link deleteSerie} - Eliminar serie
* {@link updateSerie} - Actualizar serie
*/

    /**
     * Obtener todads las series
     * @param {*} queryParams 
     * @returns series 
     */
    export const getSeries = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/series', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener serie
     * @param {integer} id ID de la serie 
     * @returns serie
     */

    export const getSerie = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/series/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir serie
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addSerie = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/series`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar serie
     * @param {integer} id ID de la serie a borrar
     * @returns 
     */

    export const deleteSerie = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/series/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar serie
     * @param {integer} id ID de la serie a actualizar 
     * @returns 
     */

    export const updateSerie = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/series/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }










